import clsx from 'clsx'
import React from 'react'

type PropType = {
    selected: boolean
    url: string
    onClick: () => void
}

export const Thumb: React.FC<PropType> = ({ selected, url, onClick }) => {

    return (
        <button
            onClick={onClick}
            type="button"
            className={clsx([
                'border rounded p-1 w-20 h-20 flex-shrink-0',
                selected ? 'ring-2 ring-blue-500' : null
            ])}
        >
            <img className='w-full h-full object-cover rounded' src={url} />
        </button>
    )
}
